import { useEffect, useState } from 'react';
import { MOBILE_MAX } from './breakpoints';

// Plain check usable from class components and event handlers.
export const isMobileViewport = (maxWidth: number = MOBILE_MAX): boolean =>
  typeof window !== 'undefined' && window.innerWidth <= maxWidth;

// Hook form for functional components. Subscribes to resize + orientationchange.
export function useIsMobile(maxWidth: number = MOBILE_MAX): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => isMobileViewport(maxWidth));
  useEffect(() => {
    const onResize = () => setIsMobile(isMobileViewport(maxWidth));
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, [maxWidth]);
  return isMobile;
}
